var _a;
import { __assign } from "tslib";
import { entityMergers } from './mergeStrategies';
import { reduxKey } from './constants';
var defaultState = {};
export var reducer = function (state, action) {
    if (state === void 0) { state = defaultState; }
    var freshEntities = action.entities ||
        (action.payload && action.payload.entities) ||
        (action.meta && action.meta.entities);
    if (freshEntities) {
        var updatedState_1 = __assign({}, state);
        Object.keys(freshEntities).forEach(function (entityType) {
            // update obj reference only for those entity groups
            // that arrived in the action
            updatedState_1[entityType] = __assign({}, state[entityType]);
            Object.keys(freshEntities[entityType]).forEach(function (entityId) {
                var existing = updatedState_1[entityType][entityId];
                var incoming = freshEntities[entityType][entityId];
                var merge = entityMergers[entityType];
                // if there is no already existing item,
                // or we don't have a special merge strategy,
                // just overwrite straight away
                if (!existing || !merge) {
                    updatedState_1[entityType][entityId] = incoming;
                    return;
                }
                // otherwise merge the two entities
                updatedState_1[entityType][entityId] = merge(existing, incoming);
            });
        });
        return updatedState_1;
    }
    return state;
};
var reducers = (_a = {},
    _a[reduxKey] = reducer,
    _a);
export default reducers;
//# sourceMappingURL=reducers.js.map